import { AlertCircle, CheckCircle2 } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import type { WizardVerdict } from "@/lib/wizardStatus";
import { cn } from "@/lib/cn";

interface WizardVerdictBannerProps {
  verdict: WizardVerdict;
  className?: string;
}

export function WizardVerdictBanner({ verdict, className }: WizardVerdictBannerProps) {
  const isOk = verdict.kind === "system-ok";

  return (
    <Card
      className={cn(
        "panel border-2",
        isOk ? "border-emerald-500/50 bg-emerald-500/5" : "border-amber-500/50 bg-amber-500/5",
        className,
      )}
    >
      <CardContent className="flex gap-4 p-5">
        {isOk ? (
          <CheckCircle2 className="mt-0.5 size-6 shrink-0 text-emerald-500" aria-hidden />
        ) : (
          <AlertCircle className="mt-0.5 size-6 shrink-0 text-amber-500" aria-hidden />
        )}
        <div className="min-w-0 space-y-1">
          <p className={cn("text-lg font-semibold tracking-tight", isOk ? "text-emerald-700 dark:text-emerald-400" : "text-amber-700 dark:text-amber-400")}>
            {verdict.headline}
          </p>
          <p className="text-sm font-medium text-foreground">{verdict.summary}</p>
          {verdict.detail ? <p className="text-sm text-muted-foreground">{verdict.detail}</p> : null}
        </div>
      </CardContent>
    </Card>
  );
}
